import { format, parseISO } from "date-fns";
import { ru } from "date-fns/locale";
import { Pencil } from "lucide-react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/shared/components/ui/table";
import { Badge } from "@/shared/components/ui/badge";
import type { User } from "../../types/users.types";
import { usersConfig } from "../../constants/users.constants";
import type { ModalType } from "../../pages/UsersPage";

interface UsersTableProps {
  users: User[];
  onClick: (modalType: ModalType["modalType"], user: User) => void;
}

export function UsersTable({
  users,
  onClick,
}: UsersTableProps) {

  /*   const formatPassengers = (passengers: Order["passengers"]) => {
    const counts = passengers.reduce((acc, passenger) => {
      acc[passenger.type] = (acc[passenger.type] || 0) + 1;
      return acc;
    }, {} as Record<string, number>);

    const parts: string[] = [];

    if (counts.adult) {
      parts.push(`${counts.adult} взр`);
    }
    if (counts.child) {
      parts.push(`${counts.child} реб`);
    }
    if (counts.infant) {
      parts.push(`${counts.infant} млд`);
    }
    return parts.join(", ");
  };
 */
  return (
    <div className="bg-white rounded-b-lg border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Имя</TableHead>
            <TableHead>Email</TableHead>
            <TableHead>Роль</TableHead>
            <TableHead>Статус</TableHead>
            <TableHead>Последний вход</TableHead>
            <TableHead>Действия</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {users.map((user) => (
            <TableRow key={user.id}>
              <TableCell className="font-medium">{`${user.name} ${user.surname}`}</TableCell>
              <TableCell>{user.login}</TableCell>
              <TableCell>{user.role}</TableCell>
              <TableCell>
                <Badge className={usersConfig[user.status].className}>
                  {usersConfig[user.status].label}
                </Badge>
              </TableCell>
              <TableCell>
                {user.last_login
                  ? format(
                      parseISO(user.last_login as string),
                      "dd.MM.yyyy HH:mm"
                    )
                  : "-"}
              </TableCell>
              <TableCell>
                <div className="flex items-center gap-1">
                  <Badge
                    className="bg-red-500 hover:bg-red-600 text-white w-7 h-7 flex items-center justify-center p-0"
                    onClick={() => onClick("delete", user)}
                  >
                    X
                  </Badge>
                  <Badge
                    className="bg-green-500 hover:bg-green-600 text-white w-7 h-7 flex items-center justify-center p-0"
                    onClick={() => onClick("edit", user)}
                  >
                    <Pencil size={14} />
                  </Badge>
                </div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
